'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright © 2016-2018 The Thingsboard Authors
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


require('leaflet/dist/leaflet.css');

var _leaflet = require('leaflet');

var L = _interopRequireWildcard(_leaflet);

require('leaflet-providers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TbOpenStreetMap = function () {
    function TbOpenStreetMap($containerElement, utils, initCallback, defaultZoomLevel, dontFitMapBounds, minZoomLevel, mapProvider) {
        _classCallCheck(this, TbOpenStreetMap);

        this.utils = utils;
        this.defaultZoomLevel = defaultZoomLevel;
        this.dontFitMapBounds = dontFitMapBounds;
        this.minZoomLevel = minZoomLevel;
        this.tooltips = [];

        if (!mapProvider) {
            mapProvider = "OpenStreetMap.Mapnik";
        }

        this.map = L.map($containerElement[0]).setView([0, 0], this.defaultZoomLevel || 8);

        var tileLayer = L.tileLayer.provider(mapProvider);

        tileLayer.addTo(this.map);

        if (initCallback) {
            setTimeout(initCallback, 0); //eslint-disable-line
        }
    }

    _createClass(TbOpenStreetMap, [{
        key: 'inited',
        value: function inited() {
            return angular.isDefined(this.map);
        }
    }, {
        key: 'updateMarkerLabel',
        value: function updateMarkerLabel(marker, settings) {
            marker.unbindTooltip();
            marker.bindTooltip('<div style="color: ' + settings.labelColor + ';"><b>' + settings.labelText + '</b></div>', { className: 'tb-marker-label', permanent: true, direction: 'top', offset: marker.tooltipOffset });
        }
    }, {
        key: 'updateMarkerColor',
        value: function updateMarkerColor(marker, color) {
            this.createDefaultMarkerIcon(marker, color, function (iconInfo) {
                marker.setIcon(iconInfo.icon);
            });
        }
    }, {
        key: 'updateMarkerIcon',
        value: function updateMarkerIcon(marker, settings) {
            this.createMarkerIcon(marker, settings, function (iconInfo) {
                marker.setIcon(iconInfo.icon);
                if (settings.showLabel) {
                    marker.unbindTooltip();
                    marker.tooltipOffset = [0, -iconInfo.size[1] + 10];
                    marker.bindTooltip('<div style="color: ' + settings.labelColor + ';"><b>' + settings.labelText + '</b></div>', { className: 'tb-marker-label', permanent: true, direction: 'top', offset: marker.tooltipOffset });
                }
            });
        }
    }, {
        key: 'createMarkerIcon',
        value: function createMarkerIcon(marker, settings, onMarkerIconReady) {
            var currentImage = settings.currentImage;
            var opMap = this;
            if (currentImage && currentImage.url) {
                this.utils.loadImageAspect(currentImage.url).then(function (aspect) {
                    if (aspect) {
                        var width;
                        var height;
                        if (aspect > 1) {
                            width = currentImage.size;
                            height = currentImage.size / aspect;
                        } else {
                            width = currentImage.size * aspect;
                            height = currentImage.size;
                        }
                        var icon = L.icon({
                            iconUrl: currentImage.url,
                            iconSize: [width, height],
                            iconAnchor: [width / 2, height],
                            popupAnchor: [0, -height]
                        });
                        var iconInfo = {
                            size: [width, height],
                            icon: icon
                        };
                        onMarkerIconReady(iconInfo);
                    } else {
                        opMap.createDefaultMarkerIcon(marker, settings.color, onMarkerIconReady);
                    }
                });
            } else {
                this.createDefaultMarkerIcon(marker, settings.color, onMarkerIconReady);
            }
        }
    }, {
        key: 'createDefaultMarkerIcon',
        value: function createDefaultMarkerIcon(marker, color, onMarkerIconReady) {
            var pinColor = color.substr(1);
            var icon = L.icon({
                iconUrl: 'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|' + pinColor,
                iconSize: [21, 34],
                iconAnchor: [10, 34],
                popupAnchor: [0, -34],
                shadowUrl: 'https://chart.apis.google.com/chart?chst=d_map_pin_shadow',
                shadowSize: [40, 37],
                shadowAnchor: [12, 35]
            });
            var iconInfo = {
                size: [21, 34],
                icon: icon
            };
            onMarkerIconReady(iconInfo);
        }
    }, {
        key: 'createMarker',
        value: function createMarker(location, settings, onClickListener, markerArgs) {
            var marker = L.marker(location, {});
            var opMap = this;
            this.createMarkerIcon(marker, settings, function (iconInfo) {
                marker.setIcon(iconInfo.icon);
                if (settings.showLabel) {
                    marker.tooltipOffset = [0, -iconInfo.size[1] + 10];
                    marker.bindTooltip('<div style="color: ' + settings.labelColor + ';"><b>' + settings.labelText + '</b></div>', { className: 'tb-marker-label', permanent: true, direction: 'top', offset: marker.tooltipOffset });
                }
                marker.addTo(opMap.map);
            });

            if (settings.displayTooltip) {
                this.createTooltip(marker, settings.tooltipPattern, settings.tooltipReplaceInfo, settings.autocloseTooltip, markerArgs);
            }

            if (onClickListener) {
                marker.on('click', onClickListener);
            }

            return marker;
        }
    }, {
        key: 'removeMarker',
        value: function removeMarker(marker) {
            this.map.removeLayer(marker);
        }
    }, {
        key: 'createTooltip',
        value: function createTooltip(marker, pattern, replaceInfo, autoClose, markerArgs) {
            var popup = L.popup();
            popup.setContent('');
            marker.bindPopup(popup, { autoClose: autoClose, closeOnClick: false });
            this.tooltips.push({
                markerArgs: markerArgs,
                popup: popup,
                pattern: pattern,
                replaceInfo: replaceInfo
            });
        }
    }, {
        key: 'updatePolylineColor',
        value: function updatePolylineColor(polyline, settings, color) {
            var style = {
                color: color,
                opacity: settings.strokeOpacity,
                weight: settings.strokeWeight
            };
            polyline.setStyle(style);
        }
    }, {
        key: 'createPolyline',
        value: function createPolyline(locations, settings) {
            var polyline = L.polyline(locations, {
                color: settings.color,
                opacity: settings.strokeOpacity,
                weight: settings.strokeWeight
            }).addTo(this.map);
            return polyline;
        }
    }, {
        key: 'removePolyline',
        value: function removePolyline(polyline) {
            this.map.removeLayer(polyline);
        }
    }, {
        key: 'fitBounds',
        value: function fitBounds(bounds) {
            if (bounds.isValid()) {
                if (this.dontFitMapBounds && this.defaultZoomLevel) {
                    this.map.setZoom(this.defaultZoomLevel, { animate: false });
                    this.map.panTo(bounds.getCenter(), { animate: false });
                } else {
                    var tbMap = this;
                    this.map.once('zoomend', function () {
                        if (!tbMap.defaultZoomLevel && tbMap.map.getZoom() > tbMap.minZoomLevel) {
                            tbMap.map.setZoom(tbMap.minZoomLevel, { animate: false });
                        }
                    });
                    this.map.fitBounds(bounds, { padding: [50, 50], animate: false });
                }
            }
        }
    }, {
        key: 'createLatLng',
        value: function createLatLng(lat, lng) {
            return L.latLng(lat, lng);
        }
    }, {
        key: 'extendBoundsWithMarker',
        value: function extendBoundsWithMarker(bounds, marker) {
            bounds.extend(marker.getLatLng());
        }
    }, {
        key: 'getMarkerPosition',
        value: function getMarkerPosition(marker) {
            return marker.getLatLng();
        }
    }, {
        key: 'setMarkerPosition',
        value: function setMarkerPosition(marker, latLng) {
            marker.setLatLng(latLng);
        }
    }, {
        key: 'getPolylineLatLngs',
        value: function getPolylineLatLngs(polyline) {
            return polyline.getLatLngs();
        }
    }, {
        key: 'setPolylineLatLngs',
        value: function setPolylineLatLngs(polyline, latLngs) {
            polyline.setLatLngs(latLngs);
        }
    }, {
        key: 'createBounds',
        value: function createBounds() {
            return L.latLngBounds();
        }
    }, {
        key: 'extendBounds',
        value: function extendBounds(bounds, polyline) {
            if (polyline && polyline.getLatLngs()) {
                bounds.extend(polyline.getBounds());
            }
        }
    }, {
        key: 'invalidateSize',
        value: function invalidateSize() {
            this.map.invalidateSize(true);
        }
    }, {
        key: 'getTooltips',
        value: function getTooltips() {
            return this.tooltips;
        }
    }]);

    return TbOpenStreetMap;
}();

exports.default = TbOpenStreetMap;


// WEBPACK FOOTER //
// ./src/app/widget/lib/openstreet-map.js